import { createSlice } from '@reduxjs/toolkit';
import {
  getAllVendorFaQBuilder,
  getVendorFaQForUserBuilder,
  createVendorFaQBuilder,
  updateVendorFaQBuilder,
  deleteVendorFaQBuilder,
} from './builder';
import { LOGOUT } from '../../constants';

const initialState = {
  allFAQ: {
    data: [],
    total: 0,
    perPage: 12,
    maxReached: false,
  },
  selectedFAQ: {},
  getVendorFaQForUserPending: false,
  getAllVendorFaQPending: false,
  updateVendorFaQPending: false,
  deleteVendorFaQPending: false,
  createVendorFaQPending: false,
};

export const commonSlice = createSlice({
  name: 'commonInfo',
  initialState,
  reducers: {},
  extraReducers: builder => {
    getAllVendorFaQBuilder(builder);
    getVendorFaQForUserBuilder(builder);
    createVendorFaQBuilder(builder);
    updateVendorFaQBuilder(builder);
    deleteVendorFaQBuilder(builder);
    builder.addCase(LOGOUT, () => initialState);
  },
});

export const selectAllFAQ = state => state.commonInfo.allFAQ;
export const selectFAQById = state => state.commonInfo.selectedFAQ;
export const selectGetAllVendorFaQPending = state => state.commonInfo.getAllVendorFaQPending;
export const selectGetVendorFaQForUserPending = state => state.commonInfo.getVendorFaQForUserPending;
export const selectCreateVendorFaQPending = state => state.commonInfo.createVendorFaQPending;
export const selectDeleteVendorFaQPending = state => state.commonInfo.deleteVendorFaQPending;
export const selectUpdateVendorFaQPending = state => state.commonInfo.updateVendorFaQPending;

// export const {} = commonSlice.actions;

export default commonSlice.reducer;
